import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
} from '@mui/material';
import { useCreateTask } from '../hooks/useTasks';

const CreateTaskDialog = ({ open, onClose }) => {
  const [newTask, setNewTask] = useState({
    title: '',
    description: '',
    column: 'backlog',
  });

  const createTask = useCreateTask();

  const handleCreate = () => {
    if (newTask.title.trim()) {
      createTask.mutate(newTask, {
        onSuccess: () => {
          setNewTask({ title: '', description: '', column: 'backlog' });
          onClose();
        },
      });
    }
  };

  const handleClose = () => {
    setNewTask({ title: '', description: '', column: 'backlog' });
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>Create New Task</DialogTitle>
      <DialogContent>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 1 }}>
          <TextField
            autoFocus
            label="Task Title"
            fullWidth
            variant="outlined"
            value={newTask.title}
            onChange={(e) => setNewTask({ ...newTask, title: e.target.value })}
            required
          />
          <TextField
            label="Description"
            fullWidth
            multiline
            rows={3}
            variant="outlined"
            value={newTask.description}
            onChange={(e) => setNewTask({ ...newTask, description: e.target.value })}
          />
          <FormControl fullWidth variant="outlined">
            <InputLabel>Column</InputLabel>
            <Select
              value={newTask.column}
              onChange={(e) => setNewTask({ ...newTask, column: e.target.value })}
              label="Column"
            >
              <MenuItem value="backlog">Backlog</MenuItem>
              <MenuItem value="in-progress">In Progress</MenuItem>
              <MenuItem value="review">Review</MenuItem>
              <MenuItem value="done">Done</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button
          onClick={handleCreate}
          variant="contained"
          color="primary"
          disabled={!newTask.title.trim() || createTask.isLoading}
        >
          {createTask.isLoading ? 'Creating...' : 'Create Task'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateTaskDialog;
